import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';

const ModernMyCarsDetails = ({ link, label, onClick, isInline }) => {
	return (
		<a
			className={setClassNames([
				'modern-my-cars-details-label',
				'd-flex',
				'align-items-center',
				'p-0',
				'text-body',
				isInline ? 'flex-row' : 'flex-column',
				isInline ? 'ml-auto' : ''
			])}
			href={link}
			onClick={onClick}
		>
			{!isInline && <i className="ddc-icon ddc-icon-arrow-details" />}
			<span className="ddc-font-size-small">{label}</span>
			{isInline && <i className="ml-2 ddc-icon ddc-icon-arrow-details" />}
		</a>
	);
};

ModernMyCarsDetails.propTypes = {
	link: PropTypes.string,
	label: PropTypes.string,
	onClick: PropTypes.func,
	isInline: PropTypes.bool
};

export default ModernMyCarsDetails;
